<template>
  <div>Oldtimers API is {{ api }} BTW <span v-if="api === 'OK'">... Thanks for asking ;)</span><span v-else>:(</span></div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from '@/components/utils/Config'
Vue.use(VueAxios, axios)
export default {
  computed: {
    api () {
      return this.$store.state.api
    }
  },
  created () {
    Vue.axios.get(config.urls.api_ok)
    .then((response) => {
      this.$store.commit('updateApi', response.data)
    })
    .catch(function (error) {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// ApiCheck.vue?27716e76